import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import { createStore } from "redux";
import storeContainer from './store/main.js';
import {Provider} from 'react-redux';
import history from './utils/HistoryApp.js';
import {PersistGate} from 'redux-persist/integration/react';

let store = storeContainer(history);
ReactDOM.render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <App history={history} />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
